class TradeProgram {
  constructor() {
    this.tradeProgram = window.themeVariables?.tradeProgram;
    this.isB2B = window.themeVariables?.settings?.isB2B === true;
    this.storageKey = 'tradeprice';

    if (this.tradeProgram?.enabled === false || this.isB2B) {
      localStorage.removeItem(this.storageKey);
      this.reveal();
      return;
    }

    this.stampTradePrice();
    this.apply();
  }

  isTradeProgramPage() {
    const handle = this.tradeProgram?.page;
    if (!handle) return false;

    const segments = window.location.pathname.split('/').filter(Boolean);
    const pagesIndex = segments.lastIndexOf('pages');
    if (pagesIndex === -1) return false;

    return segments[pagesIndex + 1] === handle;
  }

  stampTradePrice() {
    if (!this.isTradeProgramPage()) return;
    if (localStorage.getItem(this.storageKey)) return;

    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    localStorage.setItem(this.storageKey, `${now.getFullYear()}-${month}-${day}`);
  }

  isExpired(storedDate) {
    const started = new Date(`${storedDate}T00:00:00`);
    if (Number.isNaN(started.getTime())) return true;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const daysPassed = Math.floor((today.getTime() - started.getTime()) / 86400000);
    const cap = Number(this.tradeProgram?.frequencyCapped) || 0;

    return daysPassed > cap;
  }

  reveal() {
    document.documentElement.classList.remove('trade-price-hidden');
    document.querySelectorAll('[data-trade-program-button]').forEach((element) => element.remove());
    document.querySelectorAll('.badge--on-trade').forEach((element) => element.remove());
  }

  apply() {
    const stored = localStorage.getItem(this.storageKey);

    if (!stored || this.isExpired(stored)) {
      if (stored) localStorage.removeItem(this.storageKey);
      this.reveal();
      return;
    }

    this.applyTradeUi();
    this.clearCart();
    this.bindBlockedKlaviyoPopups();
  }

  applyTradeUi() {
    const run = () => {
      document.querySelectorAll('[data-trade-program-button]').forEach((element) => {
        element.classList.remove('hidden');
      });
      document.querySelectorAll('.badge--on-trade').forEach((element) => {
        element.classList.remove('hidden');
      });

      document.querySelectorAll('price-list').forEach((element) => element.classList.add('hidden'));
      document.querySelectorAll('.buy-buttons-container').forEach((element) => element.classList.add('hidden'));
      document.querySelectorAll('product-sticky-bar').forEach((element) => element.classList.add('hidden'));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  }

  async clearCart() {
    const root = window.Shopify?.routes?.root || '/';

    try {
      const cartResponse = await fetch(`${root}cart.js`);
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      if (!cart.item_count) return;

      const clearResponse = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      if (clearResponse.ok) window.location.reload();
    } catch (error) {
      console.error('Trade program cart clear failed:', error);
    }
  }

  bindBlockedKlaviyoPopups() {
    if (window.__tradeProgramKlaviyoPopupBound) return;
    window.__tradeProgramKlaviyoPopupBound = true;
  
    window.addEventListener('klaviyoForms', (e) => {
      if (e.detail.type !== 'open') return;
    
      const formId = e.detail.formId;
      const blockedForms = new Set(['SnemYN', 'RPsKPA', 'UqqadJ', 'Yd8G8m']);
      const POPUP_SELECTOR = '.kl-private-reset-css-Xuajs1[aria-label=\'POPUP Form\']';
    
      const unlockBodyScroll = () => {
        if (!document.body.classList.contains('klaviyo-prevent-body-scrolling')) {
          return false;
        }
        document.body.classList.remove('klaviyo-prevent-body-scrolling');
        return true;
      };
    
      const watchScrollLock = () => {
        if (unlockBodyScroll()) return;
    
        const classObserver = new MutationObserver(() => {
          if (unlockBodyScroll()) classObserver.disconnect();
        });
    
        classObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class'],
        });
    
        setTimeout(() => classObserver.disconnect(), 3000);
      };
    
      const handlePopup = (klaviyoPopupEle) => {
        if (blockedForms.has(formId)) {
          const outerWrapper = klaviyoPopupEle.parentElement?.closest(
            '.kl-private-reset-css-Xuajs1'
          );
          (outerWrapper || klaviyoPopupEle).remove();
          watchScrollLock();
          return;
        }
    
        klaviyoPopupEle.style.setProperty('display', 'flex', 'important');
      };
    
      const existingPopup = document.querySelector(POPUP_SELECTOR);
      if (existingPopup) {
        handlePopup(existingPopup);
        return;
      }
    
      const popupObserver = new MutationObserver(() => {
        const popup = document.querySelector(POPUP_SELECTOR);
        if (!popup) return;
    
        popupObserver.disconnect();
        handlePopup(popup);
      });
    
      popupObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    
      setTimeout(() => popupObserver.disconnect(), 3000);
    });
  }
}

new TradeProgram();